import { topList } from "@/mocks/news";

export default function TopList() {
  return (
    <section id="top" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-8 lg:grid-cols-12 lg:gap-12">
          {/* 左侧标题区 */}
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-widest text-primary-600">
              <i className="ri-fire-fill" /> TODAY'S HOT
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              今日新瓜 · 热度总榜
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-500">
              综合阅读、转发与讨论真实热度实时计算。上榜未必是最大事，
              但一定是此刻最多人在吃的瓜。
            </p>

            <div className="mt-6 rounded-xl border border-accent-200 bg-accent-50 p-5">
              <p className="flex items-center gap-2 font-heading text-sm font-bold text-accent-900">
                <i className="ri-question-line rounded-full bg-accent-500 p-1 text-background-50" />
                榜单怎么算？
              </p>
              <p className="mt-2 text-xs leading-6 text-accent-900/80">
                每 5 分钟滚动更新一次，综合站内阅读量、各平台讨论声量与传播速度加权得出，
                只反映真实热度，不掺水、不买量。
              </p>
            </div>
          </div>

          {/* 榜单列表 */}
          <div className="lg:col-span-8">
            <ol className="space-y-3">
              {topList.map((t, i) => (
                <li
                  key={t.id}
                  className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-100 px-4 py-3.5 transition-colors hover:border-primary-200 hover:bg-primary-50/60 md:px-5"
                >
                  <span
                    className={
                      "w-9 shrink-0 text-center font-heading text-2xl font-black " +
                      (i < 3 ? "text-primary-500" : "text-foreground-300")
                    }
                  >
                    {i + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span
                        className={
                          "rounded px-1.5 py-0.5 text-[10px] font-bold " +
                          (t.trend === "new"
                            ? "bg-primary-100 text-primary-700"
                            : "bg-secondary-100 text-secondary-700")
                        }
                      >
                        {t.trend === "up" ? "↑ 上升" : t.trend === "down" ? "↓ 回落" : "NEW 新上榜"}
                      </span>
                      <span className="rounded bg-accent-100 px-1.5 py-0.5 text-[10px] font-bold text-accent-800">{t.tag}</span>
                    </div>
                    <h3 className="mt-1 truncate text-sm font-bold text-foreground-900 group-hover:text-primary-700 md:text-[15px]">
                      {t.title}
                    </h3>
                  </div>
                  <span className="hidden shrink-0 items-center gap-1.5 text-xs font-semibold text-foreground-500 sm:inline-flex">
                    <i className="ri-fire-fill text-primary-500" />
                    {t.heat}
                  </span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}